module.exports = __webpack_public_path__ + "img/overlay_new.a9f9800f.svg";